import { observer } from 'mobx-react-lite';
import { DateField, FieldGroup, MultiSelectField } from '../../../components';
import KeyLabelField from '../../products/edit/pulse-keys/components/KeyLabelField';
import PulseKeyStatRequest from '../store/PulseKeyStatRequest';

export default observer(function StatForm({
  statRequest,
}: {
  statRequest: PulseKeyStatRequest;
}) {
  return (
    <FieldGroup sx={{ alignItems: 'center' }}>
      <MultiSelectField
        errorText={statRequest.errors.productIds}
        label="Products"
        name="productIds"
        onBlur={statRequest.handleBlur}
        onChange={statRequest.handleChange}
        options={statRequest.products.toOptions('All products')}
        sx={{ flex: 1, width: 240 }}
        value={statRequest.productIds}
      />
      <KeyLabelField
        errorText={statRequest.errors.label}
        label="Label"
        onBlur={statRequest.handleBlur}
        onChange={(value) => statRequest.handleChange({ name: 'label', value })}
        sx={{ mt: 2, width: 128 }}
        value={statRequest.label}
      />
      <DateField
        errorText={statRequest.errors.redeemedAtFrom}
        label="From"
        name="redeemedAtFrom"
        onBlur={statRequest.handleBlur as any}
        onChange={statRequest.handleChange}
        value={statRequest.redeemedAtFrom}
      />
      <DateField
        errorText={statRequest.errors.redeemedAtTo}
        label="to"
        name="redeemedAtTo"
        onBlur={statRequest.handleBlur as any}
        onChange={statRequest.handleChange}
        value={statRequest.redeemedAtTo}
      />
    </FieldGroup>
  );
});
